<template>
  <div :style="{ 'justify-content': align == 'left' ? 'flex-start' : 'flex-end' }">
    <v-card
      style="border-radius: 10px; overflow: hidden"
      class="card ma-1 ntn_message-card"
      :style="{ width: size == 'big' ? '300px' : '200px' }"
    >
      <!-- height: (size == 'big' ? '300' : '200') / (ratio == 'horizontal' ? 1.91 : 1) + 'px' -->
      <div
        class="card-img"
        :style="{
          height: (size == 'big' ? '300' : '200') / (ratio == 'horizontal' ? 1.91 : 1.91) + 'px'
        }"
        style="border-bottom: 1px solid #eee"
      >
        <template v-if="ntn_message.image_url">
          <div
            :style="{
              height:
                (size == 'big' ? '300' : '200') / (ratio == 'horizontal' ? 1.91 : 1.91) + 'px',
              'background-image': 'url(\'' + ntn_message.image_url + '\')'
            }"
            style="
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          "
          ></div>
          <!-- <img class="card-img-top" :src="ntn_message.image_url"  > -->
        </template>

        <template v-else>
          <div
            :style="{
              height:
                (size == 'big' ? '300' : '200') / (ratio == 'horizontal' ? 1.91 : 1.91) + 'px',
              'background-image':
                'url(\'/static/img/assets/generic/generic_default_thumbnail.png\')'
            }"
            style="
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          "
          ></div>
        </template>
      </div>

      <div
        class="card-body"
        style="padding: 0px 8px; overflow: hidden"
        :style="{ height: size == 'small' ? '120px' : '120px' }"
      >
        <h4
          class="text-xs-left"
          style="font-weight: 600; margin: 10px 0px"
          :style="{ 'font-size': size == 'big' ? 'inherit' : '12px' }"
        >
          <template v-if="ntn_message.title">
            <specialtext :text="ntn_message.title"></specialtext>
          </template>
          <template v-else></template>
        </h4>
      </div>

      <div class="card-footer">
        <ul class="list-group list-group-flush" style="margin-bottom: 0px">
          <li
            class="list-group-item"
            style="border: none; border-top: 1px solid #eee; border-radius: 0px; text-align: center"
            :style="{ padding: size == 'small' ? '5px 0' : '10px 0' }"
          >
            <template>
              <span style="color: #0084ff">
                <span
                  v-if="!isBotTest"
                  style="cursor: pointer"
                  v-clipboard:copy="ntn_message.notification_messages_cta_text"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                >
                  <!-- {{ ntn_message.notification_messages_frequency }} -->
                  {{ btnValueToText(ntn_message.notification_messages_cta_text) }}
                </span>
                <span v-else style="cursor: pointer" @click="btnClick(ntn_message)">
                  <!-- {{ ntn_message.notification_messages_frequency }} -->
                  {{ btnValueToText(ntn_message.notification_messages_cta_text) }}
                </span>
              </span>
            </template>
          </li>
        </ul>
      </div>
      <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
        >{{ $t('Copied') }}!</v-snackbar
      >
    </v-card>
  </div>
</template>

<script>
import specialtext from '@/components/elements/specialtext'
import { mapGetters } from 'vuex'

export default {
  props: {
    isBotTest: { type: Boolean, default: false },
    ntn_message: [Object, String, Array],
    size: {
      type: String,
      default: 'big'
    },
    ratio: {
      default: 'square'
    }
  },
  data() {
    return {
      align: '',
      showCopy: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    onCopyError: function() {}
  },
  methods: {
    btnValueToText(value) {
      const vm = this
      if (value === 'GET') {
        return vm.$t('get_messages')
      } else if (value === 'SIGN_UP') {
        return vm.$t('sign_up_for_messages')
      } else if (value === 'ALLOW') {
        return vm.$t('allow_messages')
      } else if (value === 'OPT_IN') {
        return vm.$t('opt_in_to_messages')
      } else if (value === 'FREQUENCY') {
        return vm.$t('get_daily_messages')
      } else {
        return value
      }
    },
    btnClick(button) {
      this.$emit('clickBtnMessage', button.notification_messages_frequency)
    },
    onCopy: function() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    }
  },
  components: {
    specialtext
  }
}
</script>

<style scoped>
.card-img {
  overflow: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/NtnViewer.vue